import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_VOYAGE_LIST:
      return { ...action.voyageList };
    case Action.CLEAR_VOYAGE_LIST:
      return {};
    default:
      return state;
  }
};
